import { useState } from "react";
import PlayerGroup from "./Components/PlayerGroup/PlayerGroup";
import './PlayerList.css'
import RolesSCP from "../../../../../Services/Data/SCP/RolesSCP";

const PlayerList = ({groupedPlayers, selectedPlayers, setSelectedPlayers}) => {

    const[sortMethod, setSortMethod] = useState(0);
    const [filter, setFilter] = useState("");

    const [, setChange] = useState("");

    const SortPlayers = (a, b) => 
    {
        switch (sortMethod) {
        case 0:
            return a.inGameId - b.inGameId;
        case 1:
            return a.nickname > b.nickname;
        case 2:
            return a.playerRoleId - b.playerRoleId;
        case 3:
          return RolesSCP[a.playerRoleId + 1].team - RolesSCP[b.playerRoleId + 1].team;
        default:
            return a.inGameId - b.inGameId;
        } 
    }

    const groupedPlayersData = groupedPlayers.map(x =>   
    {
       return {
        name: x.name,
        players: x.players
        .filter(x => x.nickname.toLowerCase().includes(filter))
        .sort((a, b) => SortPlayers(a, b))
       }
    });

    const ChangePlayerSelection = (player) => {
        let data = selectedPlayers;

        const selectedPlayer = data.find(x => x.userId == player.userId);

        if(selectedPlayer) {
            data.splice(data.indexOf(selectedPlayer), 1);   
        } else {
            data.push(player);
        }

        setSelectedPlayers(data);
  
        setChange(Date.now);
    }

    const isPlayerSelected = (player) => {
        const selectedPlayer = selectedPlayers.find(x => x.userId == player.userId);

        return selectedPlayer != null;
    }


    return (
        <div className="playerListContainer">
            <div className="playerList">
                { groupedPlayersData.map(playerGroup => 
                    <PlayerGroup playerGroup={playerGroup} isPlayerSelected={isPlayerSelected} ChangePlayerSelection={ChangePlayerSelection}/>
                )}
            </div>
            <div className="h-[10%]">
                <select className="playerSearchInput" onChange={(e) => {setSortMethod(e.target.options.selectedIndex);}}>
                    <option>Player IDs</option>
                    <option>Name (Alphabetical)</option>
                    <option>Class</option>
                    <option>Team</option>
                </select>
                <input placeholder="Search player..." className="playerSearchInput" type="text" onChange={(e) => setFilter(e.target.value.toLowerCase())}/>
            </div>
        </div>
    );
};

export default PlayerList;